import { Component, Input } from '@angular/core';
import { COMPONENTS } from '../../constants/components';

@Component({
  selector: 'component-icon',
  template: `
    <svg [ngStyle]="{ width: size + 'px', height: size + 'px' }">
      <use xmlns:xlink="http://www.w3.org/1999/xlink" [attr.href]="getIconHref()"></use>
    </svg>
  `,
})
export class ComponentIconComponent {
  @Input() type: string;
  @Input() size = 32;

  getIconHref(): string {
    return `#icons-sprite_${COMPONENTS[this.type].icon}`;
  }
}
